import React, { useState, useEffect } from "react"
import { cn } from "../../utils/common.helper"

const VRToggle = ({ mode, onModeChange }) => {
  const [localMode, setLocalMode] = useState(mode)
  const [isAnimating, setIsAnimating] = useState(false)

  useEffect(() => {
    setLocalMode(mode)
  }, [mode])

  const handleModeChange = (newMode) => {
    setIsAnimating(true)
    setLocalMode(newMode)
    onModeChange(newMode)

    // Reset animation state
    setTimeout(() => setIsAnimating(false), 400)
  }

  const toggleMode = () => {
    const newMode = localMode === "on" ? "off" : "on"
    handleModeChange(newMode)
  }

  return (
    <div className="flex flex-col items-center gap-2 select-none">
      <span
        className={cn(
          "text-sm font-medium text-muted-foreground tracking-widest transition-all duration-300",
          isAnimating && "scale-105"
        )}
      >
        SELECT VR MODE
      </span>
      <div
        className={cn(
          "inline-flex rounded-full bg-gray-200 p-1 cursor-pointer transition-all duration-300 hover:shadow-lg",
          isAnimating && "scale-105"
        )}
        onClick={toggleMode}
      >
        <button
          type="button"
          className={cn(
            "relative px-6 py-1.5 text-sm font-medium rounded-full transition-all duration-300 ease-in-out",
            localMode === "on"
              ? "bg-gradient-to-r from-[#5080FD] to-[#62AFFC] text-white shadow-sm translate-y-0 scale-105"
              : "text-gray-700 hover:bg-gray-300 hover:-translate-y-0.5",
            isAnimating && localMode === "on" && "animate-pulse"
          )}
          aria-pressed={localMode === "on"}
        >
          ON
          {localMode === "on" && (
            <span className="absolute inset-0 rounded-full bg-white opacity-15 animate-ping" />
          )}
        </button>
        <button
          type="button"
          className={cn(
            "relative px-6 py-1.5 text-sm font-medium rounded-full transition-all duration-300 ease-in-out",
            localMode === "off"
              ? "bg-gradient-to-r from-[#5080FD] to-[#62AFFC] text-white shadow-sm translate-y-0 scale-105"
              : "text-gray-700 hover:bg-gray-300 hover:-translate-y-0.5",
            isAnimating && localMode === "off" && "animate-pulse"
          )}
          aria-pressed={localMode === "off"}
        >
          OFF
          {localMode === "off" && (
            <span className="absolute inset-0 rounded-full bg-white opacity-15 animate-ping" />
          )}
        </button>
      </div>
    </div>
  )
}

export default VRToggle
